const features = [
  {
    icon: "ri-price-tag-3-line",
    title: "完全免费",
    desc: "全站漫画免费阅读，无需充值，无隐形消费，纯粹的阅读体验。",
  },
  {
    icon: "ri-arrow-down-line",
    title: "下拉式阅读",
    desc: "专为解放双手设计的下拉式阅读方式，翻页流畅，一刷到底。",
  },
  {
    icon: "ri-flashlight-line",
    title: "更新及时",
    desc: "《家庭教师》等热门漫画第一时间同步更新，抢先追更不再等待。",
  },
  {
    icon: "ri-hd-line",
    title: "高清画质",
    desc: "优质图源高清呈现，细节清晰不糊图，保护你的阅读体验。",
  },
  {
    icon: "ri-close-circle-line",
    title: "无广告干扰",
    desc: "极简清爽的阅读界面，告别弹窗轰炸，沉浸式看漫画。",
  },
  {
    icon: "ri-device-line",
    title: "全端适配",
    desc: "手机、平板、电脑全端适配，随时随地想读就读。",
  },
];

export default function Features() {
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full px-4 md:px-6 lg:px-10">
        <div className="mb-10 text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
            <i className="ri-heart-3-line" aria-hidden="true" /> 优势
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">为什么选择178漫画网</h2>
          <p className="mt-2 text-sm text-foreground-700">用心打造每一个阅读细节，只为让你看得更爽</p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((f) => (
            <article
              key={f.title}
              className="group flex gap-4 rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-500/10 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${f.icon} text-xl`} aria-hidden="true" />
              </span>
              <div>
                <h3 className="text-sm font-bold text-foreground-950 md:text-base">{f.title}</h3>
                <p className="mt-1.5 text-xs leading-6 text-foreground-700 md:text-sm">{f.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}